import {
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
} from "../actionTypes";

export const createUser = (payload) => ({
  type: CREATE_USER,
  payload,
});

export const createUserSuccess = (payload) => ({
  type: CREATE_USER_SUCCESS,
  payload,
});

export const createUserFailure = () => ({
  type: CREATE_USER_FAILURE,
});